import React from "react";
import {styled, useTheme} from "@core-ui/react-stitch";
import {XIcon} from "@core-ui/icons";

type CloseButtonProps = {
  "aria-label": string;
  isBRRedesignEnabled?: boolean;
  onClick: () => void;
};

const Root = styled.button`
  ${({theme}) => theme.utilities.unbuttonize}
  position: absolute;
  top: 0.7rem;
  right: 0.75rem;
  z-index: 1;
`;

function CloseButton({
  "aria-label": ariaLabel,
  isBRRedesignEnabled,
  onClick,
}: CloseButtonProps) {
  const theme = useTheme();

  return (
    <Root aria-label={ariaLabel} onClick={onClick}>
      <XIcon
        fillColor={isBRRedesignEnabled ? theme.color.wh : theme.color.gray60}
        size={
          isBRRedesignEnabled
            ? {width: "12px", height: "12px"}
            : {width: "18px", height: "18px"}
        }
      />
    </Root>
  );
}

export default CloseButton;
